<script setup>
import { defineEmits, defineProps, onMounted, ref } from 'vue'

const props = defineProps({
  liveVideoItems:{
    type: Array,
  }
})
const selectedVideo = ref('')
const emits = defineEmits(['changeVideoSource'])
const changeVideo = (item)=>{
  selectedVideo.value = item.class_id
  emits('changeVideoSource', item);
}
onMounted(()=>{
  selectedVideo.value = props.liveVideoItems[0].class_id
})
</script>

<template>
  <v-col cols="12" md="4">
    <div>
      <v-list>
        <v-list-item
          @click="changeVideo(item)"
          rounded="lg"
          :active="item.class_id === selectedVideo"
          color="primary"
          class="my-3"
          :class="[$vuetify.display.mdAndDown?'px-2':'px-0']"
          v-for="(item, index) in liveVideoItems" :key="index">
          <template v-if="!$vuetify.display.mdAndDown" v-slot:prepend>
            <v-img :src="item.class_image" width="80" class="ml-4 rounded-lg" />
          </template>
          <v-list-item-title class="font-weight-medium mb-1 text-wrap ">
            <span style="color: #000 !important;" class="font-weight-bolder" :class="$vuetify.display.mdAndDown?'mb-2':''">{{item.parent_name}}</span>
          </v-list-item-title>
          <v-list-item class="text-gray pa-0"  style="color: #000 !important;"  min-height="auto">
            {{item.name}}
          </v-list-item>
        </v-list-item>
      </v-list>
    </div>
  </v-col>
</template>

<style scoped lang="scss"></style>
